import css from 'styled-jsx/css';

export default css.global`:root {
  --font-size-base: 16px;
  --brand-blue: #2f2e7c;
  --brand-green: #21714b;

  --brand-default: #4e4d4d;

  --font-bold: 700;
  --font-semibold: 600;

  --animate-delay: 0.5s;

  --heading-1: 3.5rem;
  --heading-2: 2.8rem;
  --heading-3: 2.4rem;
  --heading-4: 1.8rem;
  --heading-5: 1.2rem;
  --heading-6: 1rem;

  /* font-size: var(--font-size-base); */
}

img {
  width: 100%;
}

p,
a {
  padding: 0;
  margin: 0;
  font-size: 1rem;
  color: inherit;
  line-height: 1.6;
}

.jumbotron .webinar-banner {
  /* height: 180px; */
  max-width: 1100px;
  width: 100%;
  box-shadow: 0px 0px 5px rgba(183, 183, 183, 0.529);
  margin: 2rem auto 4rem;
  /* display: none; */
  padding: 2rem;
  background: hsl(240, 100%, 97%);
  border-radius: 5px;
}

.jumbotron {
  height: auto;
  padding-bottom: 4rem;
}

.jumbotron .webinar-banner img {
  width: 100%;
}

body {
  padding: 0px;
  margin: 0px;
}

.accordion {
  border: none; /* Remove any outer borders from the accordion container */
}

.accordion-item {
  border: none; /* Remove any outer borders from the accordion item */
}

.accordion-button {
  background-color: white !important;
  color: black;
  border: none; /* Remove all borders from the button */
  border-bottom: 1px solid #ddd; /* Only apply border to the bottom */
  border-radius: 0; /* Remove border radius if any */
  padding: 1rem 1rem; /* Adjust padding if needed */
  font-weight: bold;
}

.accordion-button:focus {
  outline: none; /* Remove focus outline */
  box-shadow: none; /* Remove focus box-shadow */
}

.accordion-button:not(.collapsed) {
  color: black;
  background-color: white !important;
  border-bottom: 1px solid #ddd; /* Ensure consistent border color when expanded */
}

.accordion-button::after {
  filter: invert(0.5); /* Adjust filter if the arrow icon is not clearly visible */
}

.accordion-body {
  border-top: none;
  border-bottom: 1px solid #ddd; /* Add a bottom border to the accordion body for separation */
}




.bg-header {
  width: 70%;
  padding-top: 120px;
  margin: 0 auto;
  margin-bottom: 60px;

}
.bg-text{
  width: 50%;
  margin: 0 auto;
  padding-top: 10px;
}

.header-text {
  font-size: 64px;
  font-weight: 700;
  line-height: 75.3px;
  text-align: center;

}
.header-text-3 {
  font-size: 40px;
  font-weight: 600;
  line-height: 75.3px;
  text-align: center;

}
.body-text-3 {
  background-color: #fff;
  padding: 40px 100px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  width: 70%;
}

.pg-2{
  font-size: 59px;
  font-weight: 600;
}


.card-govmail {
  width: 390px;
  padding: 15px;
  display: flex;
  align-items:flex-start;
  justify-content: space-between;
}

.bg-image-column {
  background-image: url("https://res.cloudinary.com/dso7hgghd/image/upload/v1717259155/g-drive_1_ygpvmv.webp");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px;
  height: 100%;
  min-height: 720px;
}

.hero-text {
  color: #212429;
  font-size: 18px;
  padding-top: 22px;
  padding-bottom: 22px;
  font-weight: 500;
  line-height: 27px;
}

.hero-section {
  margin-top: 218px;
}

.hero-section .logo-sect {
  padding: 2rem 0;
}

.hero-section .logo-sect img {
  width: 64px;
  margin-right: 8px;
}

.hero-section .logo-sect .logo {
  width: 200px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--brand-default);
}

.button-row {
  width: 200px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 48px;
}

.hero-section .logo-sect .logo span {
  font-size: 1.8rem;
  width: 200px !important;
}

.hero-section .sub-title {
  font-size: 1.8rem;
}

.hero-section .cta-cont {
  margin-top: 2rem;
}

.hero-section .cta-cont .cicod-btn {
  padding: 0.8rem 1.9rem;
  position: relative;
  z-index: 1005;
  margin-right: 1rem;
}

.hero-section .text-content-sect {
  padding-bottom: 6rem;
  position: relative;
  z-index: 1;
}

.section-two {
  padding: 0rem 0;
}

.section-two .title-cont {
  text-align: center;
  padding: 1rem;
  margin-bottom: 6rem;
}

.section-two .title-cont .title {
  font-size: 3.1rem;
  color: var(--brand-green);
  font-weight: var(--font-bold);
  margin-bottom: 1rem;
}

.section-two .title-cont .sub-title {
  font-size: 1.25rem;
}

.section-two_content {
  margin: 3rem 0;
}

.section-two_content .img-cont {
  margin-bottom: 2rem;
}

.section-two_content .title {
  font-weight: var(--font-bold);
  font-size: 2.2rem;
  margin-bottom: 1rem;
}

.section-two_content .sub-title {
  font-size: 1.25rem;
  width: 100%;
}

.section-three {
  margin: 2rem 0 0;
  background: var(--brand-green);
  padding: 4rem 0;
}

.section-three .title {
  color: #0f4f31;
  font-size: 1.875rem;
  font-weight: bold;
}

.section-three .content .right {
  margin: 4rem 0;
}

.section-three .content .right .process-box {
  margin-bottom: 2rem;
}
.benefit-section {
  padding: 3rem 2rem;
  margin-bottom: 48px;
}

.benefit-section .title {
  font-size: 48px;
  font-weight: medium;
  text-align: center;
  margin-bottom: 3rem;
  text-transform: capitalize;
}

.bottom-section {
  background-color: #e6f4eb;
  margin: 0 auto;
  height: auto !important;
  max-height: fit-content;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1348px;
  padding: 180px 0px !important;
}

.bottom-section .content {
  border-radius: 19px;
  text-align: center;
}

.bottom-section .content .title {
  font-size: 20rem;
  color: var(--brand-green);
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
}

.bottom-section .content .sub-title {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.group-section {
  background: #ffffff;
  padding: 6rem 0;
}

.image-text-row, .text-row {
  margin: 10rem 0;
}

.image-text-row .image-cont {
  margin-bottom: 2rem;
}

.image-text-row .text-cont .title {
  font-weight: bold;
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  color: #050038;
}


.image-text-row .text-cont .sub-title {
  font-size: 1rem;
  color: #5F6368;
}

/* Icon box */
.icon-box {
  /* border-radius: 10px; */
  padding: 1.5rem;
  text-align: left;
}

.icon-box:last-child {
  border-right: none;
  /* Remove border on the last div */
  padding-right: 0;
}

.icon-box .icon-cont {
  margin-bottom: 1rem;
}

.icon-box .icon-cont img {
  width: 100px;
}

.icon-box .title {
  font-weight: bold;
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
}

.icon-box .text {
  font-size: 1rem;
}

.icon-box.one {
  /* background-color: #fff5e1; */
}

.icon-box.two {
  /* background-color: #F3FFF6; */
}

.icon-box.three {
  /* background-color: #C4DBF4; */
}

/* Process box */
.process-box {
  background: #fff;
  display: flex;
  color: white;
  padding: 1rem;
  border-radius: 8px;
  gap: 1rem;
  width: 100%;
  transition: transform 300ms;
}

.process-box:hover {
  transform: scale(1.1) !important;
}

.process-box .icon {
  width: 60px;
}

.process-box .icon img {
  display: block;
  width: 100%;
}

.process-box .text {
  margin-left: auto;
  width: 80%;
}

.process-box .text .title {
  font-weight: bold;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.process-box .text .sub-title {
  font-size: 1.5rem;
  color: #2c2c2c;
}

.hero-section .img-bg {
  display: none;
  background-image: url("/static/img/performance/performancehero.webp");
  background-size: contain;
  background-repeat: no-repeat;
  height: 647px;
  position: absolute;
  top: 10px;
  right: 140px;
}

.hero-section .text-content-sect .title {
  font-size: 2.625rem;
}

#footer {
  margin-top: 0;
}

.footer-btm p {
  font-size: 16px;
}

.hero-section .title {
  font-size: 3.625rem;
  color: var(--brand-green);
  font-weight: var(--font-bold);
  margin-bottom: 2rem;
  width: 363px;
}

/* .card {
    width: 100%;
    margin: 10px 0;
  } */
.card {
  flex-direction: column;
  background-color: #F8F8F8;
  border-radius: 20px;
  margin-bottom: 10px;
  padding: 10px;
  border: none;
  height: auto !important;
}

.img-resize {
  width: 100%;
  height: 100%;
}

.iconCol,
.textCol {
  flex: initial;
}


@media only screen and (max-width: 768px) {
  .hero-section {
    margin-top: 118px;
  }
  .bottom-section .content .title {
    font-size: 4rem;
    color: var(--brand-green);
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
    line-height: 70px;
  }
  .header-text {
    font-size: 30px;
    font-weight: 800;
    line-height: 45.3px;
    text-align: center;
  
  }
  .body-text-3 {
    background-color: #fff;
    padding: 40px 10px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    width: 70%;
  }
}
@media only screen and (max-width: 991px) and (min-width: 768px) {
  .hero-section {
    margin-top: 118px;
  }
  .bottom-section .content .title {
    font-size: 4rem;
    color: var(--brand-green);
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
    line-height: 70px;
  }
  .header-text {
    font-size: 30px;
    font-weight: 800;
    line-height: 45.3px;
    text-align: center;
  
  }
  .body-text-3 {
    background-color: #fff;
    padding: 40px 30px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    width: 70%;
  }}

@media (min-width: 768px) {
  .hero-section {
    margin-top: 118px;
  }
  .bottom-section .content .title {
    font-size: 4rem;
    color: var(--brand-green);
    font-weight: bold;
    margin-bottom: 1rem;
    text-align: center;
    line-height: 70px;
  }
  .hero-section .title {
    font-size: 3.625rem;
    color: var(--brand-green);
    font-weight: var(--font-bold);
    margin-bottom: 2rem;
    width: 263px;
  }

  .section-two_content .sub-title {
    font-size: 1.25rem;
    width: 90%;
  }

  .section-two_content {
    display: flex;
    align-items: center;
    gap: 8rem;
  }

  .section-two_content .img-cont {
    margin-bottom: 0;
  }

  .section-two .title-cont .sub-title {
    width: 60%;
    margin: auto;
    font-size: 1.5rem;
  }

  .section-three>.title {
    text-align: center;
  }

  .benefit-section .content {
    grid-template-columns: 1fr 1fr;
  }

  .image-text-row {
    display: flex;
    align-items: center;
    gap: 3rem;
  }

  .image-text-row .image-cont {
    width: 60%;
    margin-bottom: 0;
  }

  .image-text-row .text-cont {
    width: 40%;
  }
  .image-text-row .pg-text {
    width: 55%;
  }

  .image-text-row.right .image-cont {
    order: 2;
  }

  .bottom-section {
    padding: 2rem 0;
  }

  .bottom-section .content {
    padding: 2rem;
  }

  .image-text-row {
    margin: 8rem 0 5rem 0;
  }

  .cardContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 400px;
    min-height: 400px;
    border-radius: 20px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .iconCol {
    /* display: flex;
  align-items: center;
  justify-content: center; */
  }

  .textCol {
    flex: 2;
    padding: 34px;
  }

  .img-resize {
    width: 100%;
    height: 100%;
  }
}

@media (min-width: 1028px) {
  .hero-section {
    margin-top: 218px;
  }
  .button-row {
    width: 450px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 48px;
  }
  .icon-box {
    flex: 1;
    border-right: 1px solid rgba(0, 0, 0, 0.3);
    padding-right: 20px;
    /* Adjust spacing as needed */
    box-sizing: border-box;
  }

  .hero-section .title {
    font-size: 3.625rem;
    color: var(--brand-green);
    font-weight: var(--font-bold);
    margin-bottom: 2rem;
    width: 363px;
  }

  .hero-section {
    position: relative;
  }

  .hero-section .img-bg {
    display: block;
    width: 624px;
  }

  .hero-section .bottom-img {
    position: relative;
    z-index: 1000;
    margin-top: 0px;
  }

  .hero-section .text-content-sect {
    width: 550px;
  }

  .hero-section .text-content-sect .title {
    font-size: 3.625rem;
  }

  .hero-section .text-content-sect .sub-title {
    font-size: 1.25rem;
    line-height: 1.6;
    width: 370px;
  }

  .section-three .title {
    font-size: 2.5rem;
    width: 600px;
  }

  .section-two .title-cont .title,
  .benefit-section>.title {
    font-size: 3rem;
  }

  .section-two .title-cont .sub-title {
    font-size: 1.25rem;
    width: 60%;
  }

  .image-text-row .text-cont .title {
    font-size: 1.875rem;
  }

  .image-text-row .text-cont .sub-title {
    font-size: 1rem;
  }

  .section-three .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 3rem;
  }

  .section-three .content .left {
    order: 2;
    width: 55%;
  }

  .section-three .content .right {
    width: 38%;
    margin: 0;
  }

  .benefit-section .content {
    grid-template-columns: repeat(3, 1fr);
  }

  .image-text-row {
    gap: 6rem;
  }

  .bottom-section {
    /* padding: 8rem 0;
    height: 666px; */
    height: 100%;
    max-height: 264px;
    margin: 0 auto;
  }

  .bottom-section .container {
    
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .bottom-section .content {
    /* width: 550px;
    padding: 6rem;*/
    display: flex;
    flex-direction: column; 
    margin: 0 auto;
  }

  .bottom-section .content .title {
    font-size: 48px;
    font-weight: 700;
  }

  .bottom-section .content .sub-title {
    font-size: 1.25rem;
  }

  .cardContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .card {
    display: flex;
    width: 400px;
    padding: 20px;
    border-radius: 20px;
    box-sizing: border-box;
  }

  .iconCol {
    /* flex: 1;
  display: flex;
  align-items: center;
  justify-content: center; */
  }

  .textCol {
    /* flex: 2;
  padding-left: 20px; */
  }

  .img-resize {
    width: 100%;
    height: 100%;
  }
}

@media (min-width: 1400px) {
  .hero-section {
    margin-top: 218px;
  }
  .button-row {
    width: 450px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 48px;
  }
  .hero-section .img-bg {
    width: 100;
  }

  .section-two_content .sub-title {
    font-size: 1.25rem;
    width: 90%;
  }

  .hero-section .title {
    font-size: 3.625rem;
    color: var(--brand-green);
    font-weight: var(--font-bold);
    margin-bottom: 2rem;
    width: 463px;
  }

  .icon-box {
    flex: 1;
    border-right: 1px solid rgba(0, 0, 0, 0.3);
    padding-right: 20px;
    box-sizing: border-box;
  }

  .icon-box:last-child {
    border-right: none;
    padding-right: 0;
  }

  .cardContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .card {
    flex: 1 1 calc(33.333% - 40px); /* Adjust this value based on the desired number of cards per row */
  margin: 20px; /* Smaller margin to reduce the gap */
    display: flex;
    width: 350px;
    height: 200px;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 0;
  }
  .cardio {
    flex: 1 1 calc(33.333% - 40px); /* Adjust this value based on the desired number of cards per row */
  margin: 20px; /* Smaller margin to reduce the gap */
    display: flex;
    width: 350px;
    height: 200px;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 0;
  }

  .card-text {
    font-size: 23.7px;
  }

  .card-subtext {
    font-size: 12.51px;
  }

  .card-drive {
    width: 290px;
    height: 352px;
    border: 1px solid #ccc;
    border-radius: 6.58px;
    padding: 15px;
    padding-top: 50px !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    

  }

  .iconCol {
    /* display: flex;
  align-items: center;
  justify-content: center; */
  }

 

  .textCol h2 {
    font-size: 21px;
    font-weight: 700;
  }

  .img-resize {
    width: 100%;
    height: 100%;
  }
}`